import { Claim } from 'src/app/services/accounts/accounts.model';

export const removeEmptyClaims = (claims: Claim[]) => {
  return claims.filter(claim => {
    const value = claim.claimValue;
    return value !== '' && value !== null && value !== undefined;
  });
};
